export default __webpack_public_path__ + "static/media/Chhatt_gen_f.b5fde7fd.wav";